import React from "react";
import { Button, Modal } from "react-bootstrap";
import ActionButton from "../button/ActionButton";
import WhiteGreenButton from "../button/whiteGreenButton";

const OcrResponseModal = ({
    text,
    onClickAccept,
    onClickReject,
    modalStatus,
    yesBtnTxt='Yes',
    noBtnTxt="No",
    loaderActive,
    loadingButtonName

}) => {
  console.log(text,"result")
  return (
    <Modal className="fade" show={modalStatus} style={{}}>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ padding: "30px", flexDirection: "column" }}>
        <div
          style={{
            fontSize: "24px",
            fontWeight: "600",
           
            padding: "20px",
            display:'flex',
            flexDirection:'column',
            textAlign:'justify'
          }}>
           {text?.note_chr =="" ? "Not able to detect anything from screen" :(<span
                                        dangerouslySetInnerHTML={{
                                          __html: text?.note_chr,
                                        }}
                                        style={{fontSize:'14px'}}
                                      />)} 

{/* <span>Scan device info: {text.predicted_object_category == "" ? "NA" : text.predicted_object_category}</span>
            <span>Model number: {text.predicted_object_model_number == "" ? "NA" : text.predicted_object_model_number}</span>
            <span>Brand name: {text.predicted_object_brand == "" ? "NA" : text.predicted_object_brand}</span>
            <span>Serial number: {text.predicted_object_serial_number == "" ? "NA" : text.predicted_object_serial_number}</span>
            <span>Other Info: {text.predicted_object_all_info == "" ? "NA" : text.predicted_object_all_info}</span>   */}
               </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "70%",
          }}>
       
       {!loaderActive  &&
       
       <>
          <WhiteGreenButton
            onClick={onClickReject}
            buttonName={noBtnTxt}
            className={'white-background-btn'}
            variant={'primary'}
          />
{!text?.note_chr =="" &&
          <WhiteGreenButton
            onClick={onClickAccept}
            buttonName={yesBtnTxt}
            className={'green-background-btn'}
            variant={'primary'}
          />}
          
          </>
          
          }
       

          {loaderActive &&  <WhiteGreenButton
            
            buttonName={loadingButtonName}
            className={'white-background-btn'}
            variant={'primary'}
          />}
        </div>
      </div>
    </Modal>
  );
};

export default OcrResponseModal;
